export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/people/Siports/61587046582233/',
  instagram: 'https://www.instagram.com/siports_/',
  linkedin: 'https://ma.linkedin.com/company/siport-event',
} as const;
